/* eslint-disable */

// This file is generated by genTypedKeys.js. Do not edit manually.

export class Auth_PopUpPendingHint {
  static readonly key: string = "Auth.PopUpPendingHint";
}
export class Auth_PopUpFailedHint {
  static readonly key: string = "Auth.PopUpFailedHint";
}
export class Auth_PopUpSuccessHint {
  static readonly key: string = "Auth.PopUpSuccessHint";
}
export class BreadcrumbLabel {
  static readonly key: string = "BreadcrumbLabel";
}
export class CloseButtonLabel {
  static readonly key: string = "CloseButtonLabel";
}
export class CommonTerms_Label {
  static readonly key: string = "CommonTerms.Label";
  label!: string;
}
export class CommonTerms_Parentheses {
  static readonly key: string = "CommonTerms.Parentheses";
  text!: string;
}
export class DocumentListAriaDescription {
  static readonly key: string = "DocumentListAriaDescription";
}
export class NoResultsMessageTitle {
  static readonly key: string = "NoResultsMessageTitle";
  queryText!: string;
}
export class NoResultsMessageSubTitle {
  static readonly key: string = "NoResultsMessageSubTitle";
}
export class SearchAction {
  static readonly key: string = "SearchAction";
}
export class SearchAria {
  static readonly key: string = "SearchAria";
}
export class SearchErrorMessageTitle {
  static readonly key: string = "SearchErrorMessageTitle";
}
export class SearchErrorMessageSubTitle {
  static readonly key: string = "SearchErrorMessageSubTitle";
}
export class SearchPlaceholder {
  static readonly key: string = "SearchPlaceholder";
}
export class SearchEmptyStateMessage {
  static readonly key: string = "SearchEmptyStateMessage";
}
export class SelectAction1 {
  static readonly key: string = "SelectAction1";
}
